import { ConvexReactClient } from "convex/react";

export const convexUrl = "http://localhost:3000";
export const convex = new ConvexReactClient(convexUrl);
